export default __webpack_public_path__ + "static/media/ctj.355cfa15.JPG";